// extracted by mini-css-extract-plugin
module.exports = {"button":"button__1SGz3","trimmed":"trimmed__2WjIr"};